import { Box, IconButton, Typography } from "@mui/material";
import React from "react";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import GridOnIcon from "@mui/icons-material/GridOn";
import { useDispatch, useSelector } from "react-redux";
import { catchElement, elementToBase64 } from "../analyzeUtils";
import { exportFile_Data } from "../analyzeSlice";
import { transform } from "lodash";
import { Translate } from "@mui/icons-material";

export default function ExportIcons() {
  const dispatch = useDispatch();
  const state = useSelector((store) => store.analyze);
  const {
    selectedScenarioName,
    duration,
    tableData,
    selectedCountry,
    selectedSkuPgName,
    selectedCountryID,
    selectedScenarioID,
    showChart,
  } = state;

  async function exportDataAsFile(isPdf) {
    console.log(showChart);
    const columnChartElement = catchElement(".columnChart");
    const multiLineChartElement = catchElement(".multiLineChart");
    const columnChartBase64 = await elementToBase64(columnChartElement);
    const multiLineChartBase64 = await elementToBase64(multiLineChartElement);
    const base64Array = [columnChartBase64, multiLineChartBase64];
    const displayType =showChart?"graph":"table";
    let postData = {
      isPdf,
      AnalyzeTitle: `Analyze ${selectedScenarioName} Data`,
      CountryID: selectedCountryID,
      CountryName: selectedCountry,
      Duration: duration,
      ProductName: selectedSkuPgName,
      ScenarioID: selectedScenarioID,
      ScenarioName: selectedScenarioName,
      chartImage: base64Array,
      listAnalyseData: tableData,
      displayType:displayType,
    };
    dispatch(exportFile_Data(postData));
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
        marginLeft: "calc(100% - 100px)",
      }}
    >
      <IconButton onClick={(e) => exportDataAsFile(false)}>
        <GridOnIcon sx={{ color: "green.main" }} />
      </IconButton>
      <IconButton onClick={(e) => exportDataAsFile(true)}>
        <PictureAsPdfIcon sx={{ color: "red.main" }} />
      </IconButton>
    </Box>
  );
}
